import * as AuthActions from "./authActions";

export default AuthActions;
